import { render, staticRenderFns } from "./EditContactOnSiteDialogComponent.vue?vue&type=template&id=772c1dc5&"
import script from "./EditContactOnSiteDialogComponent.vue?vue&type=script&lang=js&"
export * from "./EditContactOnSiteDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports